import type { RecipientStatus, ReferralOutcome, ReferralStatus } from '../api/referralsApi';

/** One office's copy of a slip. */
export const RECIPIENT_STATUS_LABEL: Record<RecipientStatus, string> = {
  pending: 'Not sent',
  sent: 'Sent, not opened',
  viewed: 'Opened',
  scheduled: 'Patient scheduled',
  completed: 'Patient seen',
  declined: 'Declined',
  superseded: 'Patient went elsewhere',
  cancelled: 'Cancelled',
};

export const OUTCOME_LABEL: Record<ReferralOutcome, string> = {
  scheduled: 'Patient scheduled',
  seen: 'Patient seen',
  not_seen: 'Patient never went',
  declined_all: 'Every office declined',
};

export const STATUS_LABEL: Record<ReferralStatus, string> = {
  draft: 'Draft',
  sent: 'Sent',
  viewed: 'Viewed',
  scheduled: 'Scheduled',
  completed: 'Completed',
  declined: 'Declined',
  cancelled: 'Cancelled',
};

/** What the receiving office sees as the banner over the slip (Refera's "Awaiting to be scheduled"). */
export const STATUS_HEADLINE: Record<ReferralStatus, { sent: string; received: string }> = {
  draft: { sent: "You haven't sent this referral", received: 'Draft' },
  sent: { sent: 'Sent, not yet opened', received: 'Awaiting to be scheduled' },
  viewed: { sent: 'Opened by the receiving office', received: 'Awaiting to be scheduled' },
  scheduled: { sent: 'Patient scheduled', received: 'Patient scheduled' },
  completed: { sent: 'Treatment completed', received: 'Completed' },
  declined: { sent: 'Declined by the receiving office', received: 'Declined' },
  cancelled: { sent: 'Cancelled', received: 'Cancelled by the referring office' },
};
